import React, {useEffect,useState} from "react";
import {post} from './../../networking/Api';
import Constent from './../../networking/Constent';
import {Alert} from "./../../alertServices";
import { withTranslation } from 'react-i18next';
import moment from 'moment';

const dummyImage =  process.env.PUBLIC_URL + '/assets/img/default-user.jpg';
let DETAILS = [];
let ASSIGN_USERS = [];
function ProjectOverview(props){
    const [projectDetails, setProjectDetails] = useState(DETAILS);
    const [projectAssign, setProjectAssign] = useState(ASSIGN_USERS);
    const [percantage, setPercantage] = useState(0);
    useEffect(() => {
        getProjectDetails();
    },[]);

    function getProjectDetails(){
        var formData=new FormData();
        formData.append("project_id",props.project_id);
        formData.append("department_id",localStorage.getItem('department_id'));
        
        post(Constent.PROJECTDETAILS,formData).then(response =>{
            if(response.status===1){
                setProjectDetails(response.project_data);
                setProjectAssign(response.project_assign);
                var totalTask = response.project_data.task_open + response.project_data.task_completed;
                totalTask = (totalTask !== 0) ? totalTask : 1;
                setPercantage(Math.floor( (response.project_data.task_completed * 100) / (totalTask) ))
            }else{
                Alert.error({title: response.message});
            }
        })
    }
    return (
	<>
	   <div className='project-userpage transaction-area mg-bottom-40'>
            <div style={{marginTop:20}}>
                <div className='single-goal'>
                        <div className="row">
                            <div className="col-12">
                                <b className="text-overflow">{projectDetails.project_name}</b>
                            </div>
                        </div>
                        <p style={{margiBottom: 5}}> <b>{projectDetails.task_open}</b> <span className="color-gray">Open Tasks</span>, <b>{projectDetails.task_completed}</b> <span className="color-gray">completed Task</span></p>
                        <p className="primary-text">
                            <i className="fa fa-calendar" aria-hidden="true"></i> &nbsp;&nbsp;
                            {moment(projectDetails.project_start_date, "YYYY-MM-DD").format("MMM DD, YYYY")}
                        </p>  
                    </div>

                    <div className='single-goal'>
                        <p><b className="text-overflow">Description :</b></p>
                        <div className="color-gray" dangerouslySetInnerHTML={{__html: (projectDetails.note)}}></div>
                    </div>

                    <div className='single-goal'>
                        <div><b>Deadline :</b></div>
                        <div className="color-gray">
                        {(projectDetails.project_end_date !== '') ? 
                        moment(projectDetails.project_end_date, "YYYY-MM-DD").format("MMM DD, YYYY")
                         : ''}</div>
                        <br></br>
                        <div><b>Project Leader :</b></div>
                        <div>
                            <img src={dummyImage} alt="img" style={{width: 30,height: 30}}/>
                        </div>
                        <div><b>Team :</b></div>
                        <div>
                            {projectAssign.map((item,key) => (
                                <img key={key} src={item.image} alt="img" className="project-assign-img"/>
                            ) )}
                        </div>
                        <br></br>
                        <div className="row">
                            <div className="col-10">
                                <b>Progress</b>
                            </div>
                            <div className="col-2 primary-text">
                                <b>{percantage}%</b>
                            </div>
                        </div>
                        <div className="progress mb-1" style={{'height': '0.3rem'}}>
                            <div className="progress-bar" role="progressbar" style={{width: percantage +'%'}} aria-valuenow={percantage} aria-valuemin="0" aria-valuemax="100" />
                        </div>
                    </div>

                </div>
            </div>
	</>
	);
    
}

export default (ProjectOverview)